<template>
  <AppDeleteModal
    :loading="isLoading"
    :show="show"
    :title="$t('integration_settings.delete_connection', { provider: protocolToDelete.name })"
    data-auto-testid="delete-sso-modal"
    keypath="integration_settings.permanently_delete_connection"
    :keyword="KEYWORD"
    @on-confirm="onConfirm"
    @on-close="onClose"
  />

  <!--      <template v-else>-->
  <!--        <span>-->
  <!--          {{ $t('integration_settings.permanently_delete_connection') }}-->
  <!--          <span class="dsm-DangerText">-->
  <!--            {{ $t('integration_settings.users_will_not_automatically_added') }}-->
  <!--          </span>-->
  <!--        </span>-->

  <!--        <FormFieldNext-->
  <!--          :label="$t('groups.unlink.strategy_label')"-->
  <!--          class="dsm-StrategyField dsm-FormField"-->
  <!--        >-->
  <!--          <AppRadioGroup-->
  <!--            v-model="removeStrategy"-->
  <!--            :is-error="isStrategyFieldEmpty"-->
  <!--            :options="REMOVE_STRATEGY_OPTIONS"-->
  <!--            :type="APP_RADIO_GROUP_TYPES.BLOCKS"-->
  <!--            data-testid="strategy-field-switch"-->
  <!--            name="unlink-strategy"-->
  <!--            @update:model-value="isStrategyFieldEmpty = false"-->
  <!--          >-->
  <!--          </AppRadioGroup>-->

  <!--          <AppFieldError-->
  <!--            v-if="isStrategyFieldEmpty"-->
  <!--            :show="isStrategyFieldEmpty"-->
  <!--            class="dsm-FieldError"-->
  <!--            data-testid="strategy-field-error"-->
  <!--          >-->
  <!--            {{ $t('field.required') }}-->
  <!--          </AppFieldError>-->
  <!--        </FormFieldNext>-->
  <!--      </template>-->
</template>

<script setup>
import { ref } from 'vue'

import SSOApiHandler from '@/api/sso'
import { handleError } from '@/utils/error-handling'
import { KEYWORD } from '@/utils/helpers'
import { isSaml, isSCIM } from '@/utils/sso-connection-settings'

import AppDeleteModal from '@/components/ui/AppDeleteModal/AppDeleteModal'

defineOptions({
  name: 'DeleteSSOConnectionModal'
})

const isLoading = ref(false)

const showModal = defineModel('show', {
  type: Boolean
})

const props = defineProps({
  protocolToDelete: {
    type: Object,
    default: () => ({})
  }
})

// const REMOVE_STRATEGY_OPTIONS = [
//   {
//     label: t('groups.unlink.keep_users.label'),
//     message: 'integration_settings.keep_scim_users',
//     value: true,
//     icon: 'keep-users'
//   },
//   {
//     label: t('groups.unlink.delete_users.label'),
//     message: 'integration_settings.delete_scim_users',
//     value: false,
//     icon: 'delete-users'
//   }
// ]
// const isStrategyFieldEmpty = ref(false)
// const removeStrategy = ref(null)

const emit = defineEmits({
  deleted: null
})

const api = new SSOApiHandler()

const deleteSamlConnection = async id => {
  isLoading.value = true
  try {
    await api.deleteSamlConnection({ id })
    onClose()
  } catch (error) {
    handleError({ error })
  } finally {
    isLoading.value = false
  }
}

const deleteScimConnection = async id => {
  isLoading.value = true
  try {
    await api.deleteScimConnection({ id })
    onClose()
  } catch (error) {
    handleError({ error })
  } finally {
    isLoading.value = false
  }
}

const onConfirm = async () => {
  const { id, protocol } = props.protocolToDelete

  if (isSaml(protocol)) {
    await deleteSamlConnection(id)
  } else if (isSCIM(protocol)) {
    await deleteScimConnection(id)
  }
  emit('deleted')
}

const onClose = () => {
  showModal.value = false
  // isStrategyFieldEmpty.value = false
  // removeStrategy.value = null
}
</script>

<style lang="scss" scoped>
//.dsm-DangerText {
//  color: $grade-low-color-next;
//  font-weight: fw('semi-bold');
//}

//.dsm-StrategyField {
//  margin-top: 20px;
//}
//
//.dsm-FormField {
//  --gap: 0;
//  --label-bottom-offset: 6px;
//}
//
//.dsm-FieldError {
//  line-height: 20px;
//}
</style>
